<template lang="pug">
.overflow-hidden.pt-5(
  :nv-el="navigate && !itemNavigation",
  @nv-right="move",
  @nv-left="move",
  @nv-enter="() => choose()",
  @nv-back="() => $emit('close')"
)
  .cms-header.px-5.pb-3.d-flex.align-items-center
    pr-title.pl-1 {{ carousel.name }}
    imagec.shadow.ml-3(v-if="carousel.logo", :src="carousel.logo")
  .cms-carousel.px-5.overflow-hidden
    .cms-carousel-scroll-container.d-inline-block.pb-4(style="white-space: nowrap")
      item(
        v-for="(item, index) in items",
        :data="item",
        :key="index",
        :active="itemNavigation ? true : index ? false : true",
        :nv-el="navigate && itemNavigation",
        @nv-enter.native="() => choose(item)",
        @nv-back.native="() => $emit('close')",
        :type="carousel.cardType",
        :width="cardWidth"
      )
</template>

<script>
import item from "./card.vue"
export default {
  name: "cms-row",
  components: { item },
  props: ["carousel", "navigate", "cardWidth"],
  data() {
    return {
      activeItem: 0
    }
  },
  computed: {
    items() {
      if (this.carousel.items.length <= 3) return this.carousel.items

      const res = this.carousel.items.slice(this.activeItem, this.activeItem + 4)
      if (res.length < 4) return res.concat(this.carousel.items.slice(0, 4 - res.length))
      return res
    },
    itemNavigation() {
      return this.carousel.items.length <= 3
    }
  },
  watch: {
    carousel(nval, oval) {
      if (nval !== oval) this.activeItem = 0
    }
  },
  methods: {
    choose($event) {
      let selected = $event || this.items[0]

      if (selected.content_type === "none") return false
      if (selected.layout_type === "sidepane") this.$emit("sidepane", selected)
      else __.platform.go(`/cms/${selected.parent}/${this.carousel.id}/${selected.id}`)
    },
    move($event) {
      switch ($event.detail.value) {
        case "right":
          if (this.activeItem >= this.carousel.items.length - 1) this.activeItem = 0
          else this.activeItem++
          break
        case "left":
          if (!this.activeItem) this.activeItem = this.carousel.items.length - 1
          else this.activeItem--
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.cms-header {
  .imagec {
    width: 60px;
    overflow: hidden;
  }
}
</style>
